// Copyright (c) 2016 Deere & Company

import RgaConsignmentDetails, {getDefaultState as getRgaConsignmentDetails} from '../state/rga-consignment-details';
import actions from '../../actions-list';

const setRgaConsignmentDetails = (state, action) =>
    RgaConsignmentDetails.update(state, {
        $set: action.rgaConsignmentDetails
    });

const updateRgaConsignmentValues = (state, action) => RgaConsignmentDetails.update(state, {
    [action.property]: {
        $set: action.value
    }
});

export default (state = getRgaConsignmentDetails(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_CONSIGNMENT_DETAILS]: setRgaConsignmentDetails,
        [actions.UPDATE_RGA_RETURNED_CONSIGNMENT_VALUES]: updateRgaConsignmentValues
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-consignment-details.js